import { ApiFunc, getInstance } from '@src/helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const pfcApplicationCreate: ApiFunc<`${typeof API.PFC_APPLICATION}`, 'post'> = data =>
  instance.post(API.PFC_APPLICATION, data)

export const pfcApplicationList: ApiFunc<`${typeof API.PFC_APPLICATION}`, 'get'> = data =>
  instance.get(API.PFC_APPLICATION, { params: data })

export const pfcApplicationEdit: ApiFunc<`${typeof API.PFC_APPLICATION_EDIT}`, 'get'> = data =>
  instance.get(API.PFC_APPLICATION_EDIT, { params: data })

export const pfcApplicationResetPassword: ApiFunc<`${typeof API.PFC_APPLICATION_RESET_PASSWORD}`, 'put'> = data =>
  instance.put(API.PFC_APPLICATION_RESET_PASSWORD, data)

export const pfcApplicationStatus: ApiFunc<`${typeof API.PFC_APPLICATION_STATUS}`, 'put'> = data =>
  instance.put(API.PFC_APPLICATION_STATUS, data)

export const pfcApplicationUpdate: ApiFunc<`${typeof API.PFC_APPLICATION_UPDATE}`, 'put'> = data =>
  instance.put(API.PFC_APPLICATION_UPDATE, data)

export const pfcApplicationFormAll: ApiFunc<`${typeof API.PFC_APPLICATION_FORM_ALL}`, 'get'> = data =>
  instance.get(API.PFC_APPLICATION_FORM_ALL, { params: data })

export const pfcApplicationFormCurrent: ApiFunc<`${typeof API.PFC_APPLICATION_FORM_CURRENT}`, 'get'> = data =>
  instance.get(API.PFC_APPLICATION_FORM_CURRENT, { params: data })

export const pfcApplicationFieldBatchCreate: ApiFunc<`${typeof API.PFC_APPLICATION_FORM_FIELD_BATCH}`, 'post'> = data =>
  instance.post(API.PFC_APPLICATION_FORM_FIELD_BATCH, data)

export const pfcApplicationFormFieldById: ApiFunc<`${typeof API.PFC_APPLICATION_FORM_FIELD_BATCH}{id}`, 'get'> = data =>
  instance.get(`${API.PFC_APPLICATION_FORM_FIELD_BATCH}${'id' in data ? data.id : data.name}`, {
    params: data,
  })

export const pfcPaymentList: ApiFunc<`${typeof API.PFC_PAYMENT_LIST}`, 'get'> = data =>
  instance.get(API.PFC_PAYMENT_LIST, { params: data })

export const pfcPaymentCreate: ApiFunc<`${typeof API.PFC_PAYMENT_CREATE}`, 'post'> = data =>
  instance.post(API.PFC_PAYMENT_CREATE, data)

export const pfcPaymentAll: ApiFunc<`${typeof API.PFC_PAYMENT_ALL}`, 'get'> = data =>
  instance.get(API.PFC_PAYMENT_ALL, { params: data })

export const pfcPaymentPrincipal: ApiFunc<`${typeof API.PFC_PAYMENT_PRINCIPAL}`, 'get'> = data =>
  instance.get(API.PFC_PAYMENT_PRINCIPAL, { params: data })

export const pfcPaymentConfirm: ApiFunc<`${typeof API.PFC_PAYMENT_CONFIRM}{id}`, 'put'> = data =>
  instance.put(`${API.PFC_PAYMENT_CONFIRM}${'id' in data ? data.id : data?.name}`)
